import React, { useState, useEffect } from 'react';
import { openAuthPopup } from '../utils/iframe';
import { clearAllCookies } from '../utils/cookies';

interface IframeAuthDialogProps {
  onAuthComplete: () => void;
  authAttempts: number;
}

const IframeAuthDialog: React.FC<IframeAuthDialogProps> = ({ onAuthComplete, authAttempts }) => {
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleAuthenticate = async () => {
    // On retry, clear cookies and open popup to logout endpoint
    if (authAttempts > 0) {
      clearAllCookies();
      
      setIsAuthenticating(true);
      setError(null);
      
      try {
        const popup = window.open('/api/auth/cookieClear', 'auth-popup', 'width=600,height=700,scrollbars=yes,resizable=yes');
        
        if (!popup) {
          throw new Error('Failed to open popup');
        }
        
        let authSucceeded = false;
        
        let hasRedirectedToLogin = false;
        
        const checkClosed = setInterval(() => {
          if (popup.closed) {
            clearInterval(checkClosed);
            setIsAuthenticating(false);
            onAuthComplete();
          }
          
          try {
            // After cookieClear redirects to login and auth completes, close popup
            if (popup.location.pathname === '/' || popup.location.pathname.includes('/oauth2/idpresponse')) {
              authSucceeded = true;
              clearInterval(checkClosed);
              popup.close();
              setIsAuthenticating(false);
              onAuthComplete();
            }
          } catch (e) {
            // Cross-origin error expected during auth flow
          }
        }, 1000);
        
      } catch (err) {
        setError('Authentication failed after retry');
        setIsAuthenticating(false);
        onAuthComplete();
      }
      return;
    }
    
    setIsAuthenticating(true);
    setError(null);

    try {
      await openAuthPopup();
      onAuthComplete();
    } catch (err) {
      setError('Authentication failed');
      setIsAuthenticating(false);
    }
  };

  // Auto-trigger popup on mount
  useEffect(() => {
    handleAuthenticate();
  }, []);

  if (isAuthenticating && !error) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px'
      }}>
        Authenticating...
      </div>
    );
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '2rem',
        borderRadius: '8px',
        maxWidth: '400px',
        textAlign: 'center',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      }}>
        <h2 style={{ marginBottom: '1rem' }}>Authentication Failed</h2>
        <div style={{
          backgroundColor: '#fee',
          color: '#c33',
          padding: '0.5rem',
          borderRadius: '4px',
          fontSize: '0.9rem'
        }}>
          {error}
        </div>
      </div>
    </div>
  );
};

export default IframeAuthDialog;